<template>
    <div>
        <div v-if="userProfile">
            <div class="code-item">
                <svg ref="barcodeRef"></svg>
            </div>
        </div>
    </div>
</template>

<script>
    import JsBarcode from "jsbarcode";
    import apiRepository from "@/services/ApiRepository";

    export default {
        name: "BarcodePage",
        data() {
            return {
                userProfile: null,
                displayValue: null,
            };
        },
        mounted() {
            this.fetchUserProfile();
        },
        methods: {
            fetchUserProfile() {
                apiRepository.userDataGet().then((response) => {
                    if (response && response.data) {
                        this.userProfile = response.data.userProfile;
                        this.$nextTick(() => {
                            this.generateBarcode();
                        });
                    }
                }).catch((err) => {
                    console.error("Error fetching profile:", err);
                });
            },
            generateBarcode() {
                const token = localStorage.getItem("authToken");
                if (token) {
                    const payload = token.split('.')[1];
                    const decodedPayload = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));

                    if (this.userProfile && this.$refs.barcodeRef) {
                        const uid = decodedPayload.userId;
                        const nid = this.userProfile.nid.toString().slice(-4);
                        // const dob = this.userProfile.dob?.replace(/-/g, '');
                       /* const gender = this.userProfile.gender;
                        const nationality = this.userProfile.nationality;*/
                        const barcodeData = `UID:${uid};NID:${nid}`;

                        JsBarcode(this.$refs.barcodeRef, barcodeData, {
                            format: "CODE128",
                            width: .8,
                            height: 80,
                            displayValue: false
                        });
                    }
                }
            }

        }
    };
</script>

<style scoped>
    .code-item {

    }
</style>
